import { useSendWelcomeEmailToDiners } from 'src/common/features/DinersManagement/hooks/useSendWelcomeEmailToDiners';
import { IErrorResponse } from 'src/utilities/shared-types';
import {
  SdkErrorResponse,
  pushErrorFromAPI,
  pushSuccess,
} from 'src/utilities/notifications';

export type UseSendWelcomeEmailParentAdminsProps = {
  corpId: string;
  onSuccess: () => void;
};
export type UseSendWelcomeEmailParentAdminsReturn = {
  sendEmail: (dinerIds: string[]) => Promise<void>;
  isLoading: boolean;
};

export const useSendWelcomeEmailParentAdmins = ({
  corpId,
  onSuccess,
}: UseSendWelcomeEmailParentAdminsProps): UseSendWelcomeEmailParentAdminsReturn => {
  const handleSuccess = (dinerIds: string[]) => {
    pushSuccess(
      `Your welcome email was sent to ${dinerIds.length} parent admins.`
    );
    onSuccess();
  };

  const handleError = (error: IErrorResponse | SdkErrorResponse) => {
    pushErrorFromAPI(error, {
      fallbackMessage: 'Your welcome email was not sent. Try again.',
    });
  };

  const { sendEmail, isLoading } = useSendWelcomeEmailToDiners({
    corpId,
    onSuccess: handleSuccess,
    onError: handleError,
  });

  return {
    sendEmail,
    isLoading,
  };
};
